/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsListItem
 */
export interface VccCredentialsListItem {
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsListItem
     */
    id?: string;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof VccCredentialsListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof VccCredentialsListItem
     */
    cardProvider?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsListItem
     */
    description?: string | null;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsListItem
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsListItem
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsListItem
     */
    allowEdit?: boolean;
}

export function VccCredentialsListItemFromJSON(json: any): VccCredentialsListItem {
    return VccCredentialsListItemFromJSONTyped(json, false);
}

export function VccCredentialsListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'cardProvider': !exists(json, 'cardProvider') ? undefined : GuidIdAndLabelFromJSON(json['cardProvider']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function VccCredentialsListItemToJSON(value?: VccCredentialsListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'cardProvider': GuidIdAndLabelToJSON(value.cardProvider),
        'description': value.description,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
    };
}


